import { IsDefined, IsNumber } from "class-validator";

export class BankingDepositStatsDto {
  @IsDefined()
  @IsNumber()
  qty: number;

  @IsDefined()
  @IsNumber()
  value: number;
}